import { AlunoNivelApp } from '@models/AlunoNivelApp';
import { Unidade, UnidadeSalvarPainel } from '@models/Unidade';
import {ServiceBase, Get, Post, Delete} from "./ServiceBase";
import {EcnhCookie} from "@models/ecnh/EcnhCookie";

const urlBase = `${ServiceBase.instance.defaults.baseURL}unidade/`;

export const GetById = (unidadeId: number) => {
    return Get<Unidade>(urlBase + 'detalhe/' + unidadeId)
}

export const GetByAutoescolaId = (unidadeId: number) => {
    return Get<Unidade[]>(urlBase + 'autoescola/' + unidadeId)
}

export const GetNivelPorAutoescolaId = (autoescolaId: number) => {
    return Get<AlunoNivelApp>(`${urlBase}configSite/${autoescolaId}`)
}

export const MudarFotoUnidade = (unidadeId: number, image: any) => {

    const formData = new FormData();

    // Update the formData object
    formData.append('UnidadeId', unidadeId.toString());

    formData.append('Image', image);

    return Post<string>(`${urlBase}`, formData)
}


export const SalvarPainel = async (params: UnidadeSalvarPainel) => {
    const rest = await Post(`${urlBase}salvar/painel`, params)

}



export const GetNomes = async () => {
    const rest = await Get(`${urlBase}nomes`);
    return rest;
}

export  const CookiesBuscarTodos=()=>{
    return Get<EcnhCookie[]>(`${urlBase}ecnh-cookie`)

}

export  const CookiesExcluir=(cookieId)=>{
    return Delete<any>(`${urlBase}ecnh-deletar/${cookieId}`)
}
export  const CookiesForcar=()=>{
    return Get(`${urlBase}ecnh-forcar`)
}
